const actions = {
    // async setModule ({ commit, dispatch }, module){
    //     commit(SET_MODULE, module);
    //     await dispatch('setGlobalConfig', module, {root:true});
    // },
};

export default actions;